import { render, staticRenderFns } from "./RejectEventPage.vue?vue&type=template&id=9866030a&"
import script from "./RejectEventPage.vue?vue&type=script&lang=js&"
export * from "./RejectEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports